module.exports = __webpack_public_path__ + "static/segmentation-location-2-fb38cd570aa187dddce3deb2ab46ece5.png";